import React, { useEffect, useState } from "react";
import "./completePHProfile.css";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import AxiosInstance from "../../../AxiosInstance";
import { Controller, useForm } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import OtherPageHeader from "../../../components/OtherHeader";
import { Option } from "antd/es/mentions";
import {
  banksListController,
  countriesListController,
  statesListController,
} from "../../Helper/provider";
import { alertError } from "../../Helper/Alerts";
import { Spinner } from "react-bootstrap";
import { uploadProfileDocumentToAWS } from "../../Helper/uploadDocument";
import { getBankAccountType } from "../../../utils";
import { occupationOptions } from "../../../utils/dropDownOptions";
export default function CompletePHProfile() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });
  const navigate = useNavigate();
  const [panDoc, setpanDoc] = useState();
  const [loading, setLoading] = useState(false);
  const [aadharDoc, setaadharDoc] = useState();

  const [cancelledChecqDoc, setcancelledChecqDoc] = useState();
  const [countries, setCountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [bankList, setBankList] = useState([]);

  const [isPanVerified, setIsPanVerified] = useState(false);
  const [verifyAadhaarModalState, setVerifyAadhaarModalState] = useState(false);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [profileData, setProfileData] = useState({});
  const occupationChange = (value) => {
    setValue("occupation", value);
  };
  const getProfileDataNew = async () => {
    let profileData = {};
    const result = await AxiosInstance()
      .get(`/user/me`)
      .catch((error) => {});
    profileData = result.data;
    setProfileData(result.data);

    if (profileData) {
      console.log(profileData);
      if (profileData.isPanVerified && profileData.pan) {
        // pan field will be disable only if pan number is also available
        setValue("pan", profileData.pan);
        setIsPanVerified(true);
        console.log("pan verified");
      }
      if (profileData.pan) {
        setValue("pan", profileData.pan);
      }
      if (profileData.isAadhaarVerified && profileData.aadhar) {
        // aadhaar field will be disable only if pan number is also available
        setIsAadhaarVerified(true);
      }
      if (profileData.aadhar) {
        setValue("aadhar", profileData.aadhar);
      }
      if (profileData.gender) setValue("gender", profileData.gender);
      if (profileData.address) setValue("address", profileData.address);
      if (profileData.occupation)
        setValue("occupation", profileData.occupation);
      if (profileData.relativeName)
        setValue("relativeName", profileData.relativeName);
      if (profileData.city) setValue("city", profileData.city);
      if (profileData.countryId) {
        countryChange(profileData.countryId);
      }
      if (profileData.stateId) {
        stateChange(profileData.stateId);
      }
      if (profileData.pinCode) setValue("pinCode", profileData.pinCode);
      if (profileData.bankAccountNumber)
        setValue("bankAccountNumber", profileData.bankAccountNumber);
      if (profileData.bankId) {
        bankNameChange(profileData.bankId);
      }
      if (profileData.accountType) {
        accountTypeChange(profileData.accountType);
      }
      if (profileData.IFSCCode) setValue("IFSCCode", profileData.IFSCCode);
      if (profileData.PANDocument)
        setValue("PANDocument", profileData.PANDocument);
      if (profileData.cancelledCheck)
        setValue("cancelledCheck", profileData.cancelledCheck);

      if (profileData.AADHARDocument)
        setValue("AADHARDocument", profileData.AADHARDocument);
      // if (profileData.UPICode) setValue("UPICode", profileData.UPICode);
      // if (profileData.EIANumber) setValue("EIANumber", profileData.EIANumber);
      // if (profileData.nomineeName)
      //   setValue("nomineeName", profileData.nomineeName);
      // if (profileData.maritalStatus)
      //   setValue("maritalStatus", profileData.maritalStatus);
      // if (profileData.annualIncome)
      //   setValue("annualIncome", parseInt(profileData.annualIncome));
      // if (profileData.education) setValue("education", profileData.education);
      // if (profileData.nameOfOrganization)
      //   setValue("nameOfOrganization", profileData.nameOfOrganization);

      // if (profileData.jobTitle) setValue("jobTitle", profileData.jobTitle);
      // if (profileData.industryType)
      //   setValue("industryType", profileData.industryType);
    }
  };
  async function handleDocument(event, target) {
    switch (target) {
      case "pan":
        errors.PANDocument = false;
        setValue("PANDocument", "empty");
        setpanDoc(event.target.files[0]);
        break;
      case "aadhar":
        errors.AADHARDocument = false;
        setValue("AADHARDocument", "empty");
        setaadharDoc(event.target.files[0]);
        break;

      default:
        errors.cancelledCheck = false;
        setValue("cancelledCheck", "empty");
        setcancelledChecqDoc(event.target.files[0]);
        break;
    }
  }
  useEffect(() => {
    getProfileDataNew();
    getSpinnerData();
  }, []);
  const getSpinnerData = async () => {
    const ctn = await countriesListController();
    setCountries(ctn);
    const bnk = await banksListController();
    setBankList(bnk);
  };
  // async function uploadProfileDocumentToAWS(file) {
  //   const url = "/common/upload-policy-document";
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   const config = {
  //     headers: {
  //       "content-type": "multipart/form-data",
  //     },
  //   };
  //   try {
  //     let response = await AxiosInstance().post(url, formData, config);
  //     return response.data["policyContractFileName"];
  //   } catch (e) {
  //     return "";
  //   }
  // }
  const genderChange = (value) => {
    errors.gender = false;
    setValue("gender", value);
  };
  const countryChange = async (value) => {
    errors.countryId = false;
    setValue("countryId", parseInt(value));
    const list = await statesListController(value);
    setStateList(list);
  };
  const stateChange = (value) => {
    errors.stateId = false;
    setValue("stateId", parseInt(value));
  };
  const bankNameChange = (value) => {
    errors.bankId = false;
    setValue("bankId", parseInt(value));
  };
  const accountTypeChange = (value) => {
    errors.accountType = false;
    setValue("accountType", value);
  };
  const isMobile = useMediaQuery({ query: "(max-width: 750px)" });
  const onSubmit = async (value) => {
    if (loading) return;
    setLoading(true);
    console.log("Values.before upload..", value);
    const id = localStorage.getItem("id");
    if (panDoc) {
      value.PANDocument = await uploadProfileDocumentToAWS(panDoc, id);
    }
    if (aadharDoc) {
      value.AADHARDocument = await uploadProfileDocumentToAWS(aadharDoc, id);
    }
    if (cancelledChecqDoc) {
      value.cancelledCheck = await uploadProfileDocumentToAWS(
        cancelledChecqDoc,
        id
      );
    }

    console.log("Values after upload...", value);
    AxiosInstance()
      .put("/profile", value)
      .then(() => {
        setLoading(false);
        window.location.href = "/phDashboard";
      })
      .catch((err) => {
        setLoading(false);
        alertError(err.response.data.message);
      });
  };
  const options = [
    {
      value: "MALE",
      label: "Male",
    },
    {
      value: "FEMALE",
      label: "Female",
    },
    {
      value: "OTHERS",
      label: "Others",
    },
  ];
  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <div className="leftDiv-complete-ph-profile">
        <div className="common-width-ph">
          <button
            type="submit"
            title="back-button"
            className="back-button mt-3 mb-4"
            onClick={() => navigate(-1)}
          >
            {" "}
            <i className="fa fa-angle-left" /> Back
          </button>
          <h2>Complete your Profile</h2>

          <form id="completePHDetailsForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={`form-group`}>
              <label htmlFor="firstName">Gender</label>
              {/* <i className="bi bi-person"></i> */}
              <div className="input-group pb-3">
                <Controller
                  name="gender"
                  control={control}
                  errors={errors}
                  render={({ field: { onChange, value, ref } }) => (
                    <Select
                      placeholder="Select Gender"
                      value={getValues("gender")}
                      disabled={
                        profileData.gender && profileData.isUserVerified
                      }
                      onChange={genderChange}
                      size="large"
                      className={`${errors.gender ? "is-invalid" : ""}`}
                      options={options}
                      style={{ width: "100%" }}
                    />
                  )}
                />
                <div className="invalid-feedback">Gender is required</div>
              </div>
              <label htmlFor="pan">PAN Number</label>
              <div className="input-group pb-3">
                <input
                  id="pan"
                  type="text"
                  disabled={isPanVerified}
                  className={`form-control ${errors.pan ? "is-invalid" : ""}`}
                  placeholder=""
                  maxlength="10"
                  {...register("pan", {
                    minLength: {
                      value: 10,
                      message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
                    },
                    maxLength: {
                      value: 10,
                      message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
                    },
                  })}
                />
                <div className="input-group-append">
                  {
                    isPanVerified && (
                      <span
                        className="input-group-text  rounded-0 "
                        id="basic-addon2"
                      >
                        <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                      </span>
                    )
                    // : (
                    //   <button
                    //     disabled={!getValues("pan") || errors?.pan?.message}
                    //     class="btn btn-outline-primary rounded-0 rounded-right "
                    //     type="button"
                    //     id="button-addon2"
                    //     onClick={() => {
                    //       setVerifyPanModalState(true);
                    //     }}
                    //   >
                    //     Verify
                    //   </button>
                    // )
                  }
                </div>
                <div className="invalid-feedback">{errors?.pan?.message}</div>
              </div>

              <label htmlFor="aadhar">Aadhar Number</label>
              <div className="input-group pb-3">
                <input
                  type="text"
                  id="aadhar"
                  maxlength="12"
                  disabled={isAadhaarVerified}
                  className={`form-control ${
                    errors.aadhar ? "is-invalid" : ""
                  }`}
                  {...register("aadhar", {
                    pattern: {
                      value: /^[0-9]*$/i,
                      message: "should be a number",
                    },
                    minLength: {
                      value: 12,
                      message: "enter a valid aadhar number", // JS only: <p>error message</p> TS only support string
                    },
                  })}
                />
                <div className="input-group-append">
                  {
                    isAadhaarVerified && (
                      <span
                        className="input-group-text  rounded-0 "
                        id="basic-addon2"
                      >
                        <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                      </span>
                    )
                    // : (
                    //   <button
                    //     disabled={!getValues("aadhar") || errors?.aadhar?.message}
                    //     class="btn btn-outline-primary rounded-0 rounded-right "
                    //     type="button"
                    //     id="button-addon2"
                    //     onClick={() => {
                    //       setVerifyAadhaarModalState(true);
                    //     }}
                    //   >
                    //     Verify
                    //   </button>
                    // )
                  }
                </div>
                <div className="invalid-feedback">
                  {errors?.aadhar?.message}
                </div>
              </div>
              <label htmlFor="address">Current Address</label>
              <div className="input-group pb-3">
                <input
                  type="text"
                  className={`form-control ${
                    errors.address ? "is-invalid" : ""
                  }`}
                  id="address"
                  disabled={profileData.address && profileData.isUserVerified}
                  placeholder=""
                  {...register("address")}
                />
                <div className="invalid-feedback">Address is required</div>
              </div>
              <label htmlFor="occupation">Occupation</label>
              <div className="input-group pb-3">
                <Controller
                  name="occupation"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      className={`${errors.occupation ? "is-invalid" : ""}`}
                      onChange={occupationChange}
                      value={getValues("occupation")}
                      disabled={
                        profileData.occupation && profileData.isUserVerified
                      }
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {occupationOptions.map((item) => (
                        <Option
                          key={item.occupationId}
                          value={item.occupationId}
                        >
                          {item.occupation}
                        </Option>
                      ))}
                    </Select>
                  )}
                />
                <div className="invalid-feedback">
                  {" "}
                  {errors?.occupation?.message}
                </div>
              </div>
              <label htmlFor="relativeName">
                Father's / Mother’s / Spouse Name
              </label>
              <div className="input-group pb-3">
                <input
                  type="text"
                  className={`form-control ${
                    errors.relativeName ? "is-invalid" : ""
                  }`}
                  id="relativeName"
                  disabled={
                    profileData.relativeName && profileData.isUserVerified
                  }
                  // aria-describedby="emailHelp"
                  placeholder=""
                  {...register("relativeName")}
                />
                <div className="invalid-feedback">
                  Relative Name is required
                </div>
              </div>
              <div className="grid-form">
                <div>
                  <label htmlFor="city">City</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      disabled={profileData.city && profileData.isUserVerified}
                      className={`form-control ${
                        errors.city ? "is-invalid" : ""
                      }`}
                      id="city"
                      placeholder=""
                      {...register("city")}
                    />
                    <div className="invalid-feedback">City is required</div>
                  </div>
                </div>
                <div>
                  <label htmlFor="country">Country</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="countryId"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={` ${errors.countryId ? "is-invalid" : ""}`}
                          placeholder="Select Country"
                          value={getValues("countryId")}
                          disabled={
                            profileData.countryId && profileData.isUserVerified
                          }
                          onChange={countryChange}
                          size="large"
                          style={{ width: "100%" }}
                        >
                          {countries.map((item) => (
                            <Option key={item.countryId} value={item.countryId}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />
                    <div className="invalid-feedback">Country is required</div>
                  </div>
                </div>
              </div>
              <div className="grid-form">
                <div>
                  <label htmlFor="state">State</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="stateId"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={` ${errors.stateId ? "is-invalid" : ""}`}
                          placeholder="Select State"
                          onChange={stateChange}
                          size="large"
                          value={getValues("stateId")}
                          disabled={
                            profileData.stateId && profileData.isUserVerified
                          }
                          style={{ width: "100%" }}
                        >
                          {stateList.map((item) => (
                            <Option key={item.stateId} value={item.stateId}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />
                    <div className="invalid-feedback">State is required</div>
                  </div>
                </div>
                <div>
                  <label htmlFor="pincode">Pincode</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      maxlength="6"
                      className={`form-control ${
                        errors.pinCode ? "is-invalid" : ""
                      }`}
                      disabled={
                        profileData.pinCode && profileData.isUserVerified
                      }
                      id="pinCode"
                      placeholder=""
                      {...register("pinCode")}
                    />
                    <div className="invalid-feedback">Pincode is required</div>
                  </div>
                </div>
              </div>
              <label htmlFor="bankAccountNumber">Bank Account Number</label>
              <div className="input-group pb-3">
                <input
                  type="text"
                  disabled={
                    profileData.bankAccountNumber && profileData.isUserVerified
                  }
                  className={`form-control ${
                    errors.bankAccountNumber ? "is-invalid" : ""
                  }`}
                  id="bankAccountNumber"
                  placeholder=""
                  {...register("bankAccountNumber")}
                />
                <div className="invalid-feedback">
                  Bank Account Number is required
                </div>
              </div>
              <label htmlFor="bankName">Bank Name</label>
              <div className="input-group pb-3">
                <Controller
                  name="bankId"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      className={`${errors.bankId ? "is-invalid" : ""}`}
                      onChange={bankNameChange}
                      value={getValues("bankId")}
                      disabled={
                        profileData.bankId && profileData.isUserVerified
                      }
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {bankList.map((item) => (
                        <Option key={item.bankId} value={item.bankId}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                />
                <div className="invalid-feedback">Bank Name is required</div>
              </div>
              <label htmlFor="accountType">Account Type</label>
              <div className="input-group pb-3">
                <Controller
                  name="accountType"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      className={`${errors.accountType ? "is-invalid" : ""}`}
                      onChange={accountTypeChange}
                      value={
                        profileData.accountType
                          ? profileData.accountType
                          : getValues("accountType")
                      }
                      disabled={
                        profileData.accountType && profileData.isUserVerified
                      }
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {getBankAccountType()}
                    </Select>
                  )}
                />
                <div className="invalid-feedback">Account Type is required</div>
                {/* <input
                  type="email"
                  className="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  placeholder=""
                /> */}
              </div>
              <label htmlFor="ifscCode">IFSC Code</label>
              <div className="input-group pb-3">
                <input
                  type="text"
                  className={`form-control ${
                    errors.IFSCCode ? "is-invalid" : ""
                  }`}
                  disabled={profileData.IFSCCode && profileData.isUserVerified}
                  id="IFSCCode"
                  aria-describedby="IFSCCode"
                  placeholder=""
                  {...register("IFSCCode")}
                />
                <div className="invalid-feedback">IFSC Code is required</div>
              </div>
              {!profileData.PANDocument && (
                <div className="mb-3 mt-2">
                  <label htmlFor="formFile" className="form-label">
                    Upload PAN
                  </label>
                  <Controller
                    name="PANDocument"
                    control={control}
                    errors={errors}
                    render={(props) => (
                      <input
                        className={`form-control ${
                          errors.PANDocument ? "is-invalid" : ""
                        }`}
                        type="file"
                        id="PANDocument"
                        onChange={(event) => {
                          handleDocument(event, "pan");
                        }}
                      />
                    )}
                  />
                  <div className="invalid-feedback">Pan Card is required</div>
                </div>
              )}
              {!profileData.AADHARDocument && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Aadhar
                  </label>
                  <Controller
                    name="AADHARDocument"
                    control={control}
                    errors={errors}
                    render={(props) => (
                      <input
                        className={`form-control ${
                          errors.AADHARDocument ? "is-invalid" : ""
                        }`}
                        type="file"
                        id="formFile"
                        onChange={(event) => {
                          handleDocument(event, "aadhar");
                        }}
                      />
                    )}
                  />
                  <div className="invalid-feedback">
                    Aadhar Card is required
                  </div>
                </div>
              )}
              {!profileData.cancelledCheck && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Cancelled Cheque
                  </label>
                  <Controller
                    name="cancelledCheck"
                    control={control}
                    errors={errors}
                    render={(props) => (
                      <input
                        className={`form-control ${
                          errors.cancelledCheck ? "is-invalid" : ""
                        }`}
                        type="file"
                        id="cancelledCheck"
                        onChange={(event) => {
                          handleDocument(event, "");
                        }}
                      />
                    )}
                  />
                  <div className="invalid-feedback">
                    Cancel Cheque is required
                  </div>
                </div>
              )}
            </div>
          </form>
          <button
            className="normal-button-ph mb-5 px-5 py-2"
            form="completePHDetailsForm"
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
            )}{" "}
            {loading ? " Loading..." : "Complete Profile"}
          </button>
        </div>
      </div>
      {!isMobile && (
        <div className="rightDiv-complete-ph-profile">
          <div className="common-width-ph d-flex justify-content-center">
            <img
              style={{ width: "60%", paddingLeft: "20px" }}
              src="/assets/g8.jpg"
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
}
